import React from "react";
import "./listApiAdvantages.scss";

//Imagens:
import ImgApiAdvantages from "../../../../assets/developAndIntegrate/apiAdvantages.png";
import ImgDevelopMobileApps from "../../../../assets/developAndIntegrate/developMobileApps.png";
import ImgEmbeddedDashboards from "../../../../assets/developAndIntegrate/embeddedDashboards.png";
import { useTranslation } from "react-i18next";

function ListApiAdvantages() {

  const { t } = useTranslation()

  return (
    <div className="container-list-api-advantages">
      <div className="api-advantages">
        <div className="img-api-advantages">
          <img src={ImgApiAdvantages} alt="" />
        </div>
        <div className="texts-api-advantages">
          <h1>{t("suport.list_api_advantages.api_advantages.title")}</h1>
          <p>{t("suport.list_api_advantages.api_advantages.section_text")}</p>
        </div>
      </div>

      <div className="develop-mobile-apps">
        <div className="img-develop-mobile-apps">
          <img src={ImgDevelopMobileApps} alt="" />
        </div>
        <div className="texts-develop-mobile-apps">
          <h1>{t("suport.list_api_advantages.mobile_apps.title")}</h1>
          <p>
            {t("suport.list_api_advantages.mobile_apps.section_text_1")}
          </p>
          <p>
            {t("suport.list_api_advantages.mobile_apps.section_text_2")}
          </p>
          <p>
            {t("suport.list_api_advantages.mobile_apps.section_text_3")}
          </p>
        </div>
      </div>
      <div className="embedded-dashboards">
        <div className="img-embedded-dashboards">
          <img src={ImgEmbeddedDashboards} alt="" />
        </div>
        <div className="texts-embedded-dashboards">
          <h1>{t("suport.list_api_advantages.dashboards.title")}</h1>
          <p>{t("suport.list_api_advantages.dashboards.section_text_1")}</p>
          <p>{t("suport.list_api_advantages.dashboards.section_text_2")}</p>
        </div>
      </div>
    </div>
  );
}

export default ListApiAdvantages;
